module.exports = __webpack_public_path__ + "static/img/login_bg_left.1bf0d410.png";